import styled from 'styled-components';

export const DrawerStyled = styled.div`
    position: absolute;
    background-color: #fff;
    z-index: 200;
    width: 100%;
    bottom: 0;
    display: block;
    box-shadow:0 0 9px rgba(0, 0, 0, 0.1);

    .drag-resize {
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #E6E6E6;

        i {
            cursor: grab;
        }
    }

`;